module.exports = __webpack_public_path__ + "img/1.02.thmb.xs.c1f81a91.jpg";